import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { AssetEventType, GenericExternalSystemType } from "../../api/assetEvent";
import { ExternalSystem } from "../../api/externalSystemRequest";

export const UnappliedCashExternalSystems: ExternalSystem[] = [
    {
        title: 'Send to Asset Backed Finance Module',
        description: 'Transmit your Unapplied Cash',
        icon: '/assets/images/x.png',
        type: 'abf',
        assetEventType: AssetEventType.abf_ingestor,
        externalSystemType: GenericExternalSystemType.abf,
        failMessage: 'Failed to send to Asset Backed Finance',
        globalFailMessage: 'Unapplied Cash received an error when sending to Asset Backed Finance',
        successMessage: 'Sent to Asset Backed Finance',
        globalSuccessMessage: 'Unapplied Cash were successfully sent to Asset Backed Finance',
        waitingMessage: 'Waiting for Asset Backed Finance',
        requiredPermission: UserEntitlementCatalogs.SendToAssetBackedFinance
    }
];
